import React from 'react';
import AccountMenu from './AccountMenu';
import UserMenu from './UserMenu';
import compose from 'recompose/compose';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { connect } from 'react-redux';
import { toggleSidebar } from 'store/actions/uiActions';
import theme from 'theme/theme';
import styled from 'styled-components';

const StyledHeader = styled.header`
    background-color: ${ theme.palette.white };
    padding-right: 15px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1),0 1px 2px 0 rgba(0, 0, 0, 0.06);
`;

const Header = () => {

    return (
        <StyledHeader>
            <AccountMenu />

            <UserMenu />
        </StyledHeader>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggle: () => {
            dispatch(toggleSidebar());
        },
    };
};

const enhance = compose(
    muiThemeable(), // Force redraw on theme change
    connect(
        null,
        mapDispatchToProps,
    ),
);

export default enhance(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Layout/header/Header.js